import { AppNotifier } from "../../src/components/Common/Notification/AppNotifier";
import { AuthenticationMethod, ValidationType } from "../../src/Core/Common/Enums";
import { IFileModel } from "../Core/ViewModels/File/FileModel";
import { IRecipientModel } from "../../src/Core/ViewModels/Message/RecipientModel";
import { ISentMailMessage } from "../../src/Core/ViewModels/Message/SentMailMessageModel";
import { ISentMessageModel } from "../../src/Core/ViewModels/Message/SentMessageModel";
import { ToasterMessages } from "./ToasterMessages";

export function isValidEmailAddress(emailAddress: any) {
    if (emailAddress) {
        const pattern = new RegExp(
            /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i
        );
        return pattern.test(emailAddress);
    }
    return false;
}

export interface IValidationMessage {
    validationType: ValidationType;
    messageProperty: string;
    message: string;
}

export const validateComposeMessage = (composeMessage: ISentMailMessage) => {
    const alert: IValidationMessage = {
        validationType: ValidationType.VALID,
        messageProperty: "",
        message: "",
    };
    if (!composeMessage.recipients || composeMessage.recipients.length === 0) {
        alert.validationType = ValidationType.INVALID;
        alert.message = ToasterMessages.WARNING.REQUIRE_RECIPIENT;
    } else if (!composeMessage.messageDetail.subject) {
        alert.validationType = ValidationType.WARNING;
        alert.message = ToasterMessages.WARNING.WITHOUT_SUBJECT;
        alert.messageProperty = "subject";
    }
    return alert;
};

export const validateAllFilesUploaded = (attachments: IFileModel[]) => {
    let isValid = true;
    if (!attachments.every(a => a.isUploadComplete == true)) {
        isValid = false;
    }
    return isValid;
};

export const validateQuickReplyModel = (composeMessage: ISentMailMessage) => {
    const alert: IValidationMessage = {
        validationType: ValidationType.VALID,
        messageProperty: "",
        message: "",
    };
    if (!composeMessage.messageDetail.message) {
        alert.validationType = ValidationType.INVALID;
        alert.message = ToasterMessages.WARNING.WITHOUT_MESSAGE;
        alert.messageProperty = "message";
    }
    return alert;
};

export const validateComposeMessageModel = (composeMessage?: ISentMailMessage, recipients?: IRecipientModel[]) => {
    const alert: IValidationMessage = {
        validationType: ValidationType.VALID,
        messageProperty: "",
        message: "",
    };

    if (!composeMessage.recipients || composeMessage.recipients.length === 0) {
        alert.validationType = ValidationType.INVALID;
        alert.message = ToasterMessages.WARNING.REQUIRE_RECIPIENT;
    } else if (!validateAllRecipientsQnAComposeModal(recipients, composeMessage.messageDetail)) {
        alert.validationType = ValidationType.INVALID;
        alert.message = ToasterMessages.WARNING.REQUIRE_RECIPIENT_QUESTION_ANSWER;
    } else if (!composeMessage.attachments || composeMessage.attachments.length === 0) {
        alert.validationType = ValidationType.WARNING;
        alert.message = ToasterMessages.WARNING.WITHOUT_ATTACHMENT;
        alert.messageProperty = "attachment";
    } else if (!validateAllFilesUploaded(composeMessage.attachments)){
        alert.validationType = ValidationType.INVALID;
        alert.message = ToasterMessages.WARNING.ATTACHMENT_UPLOAD_INCOMPLETE;
    }else if (!composeMessage.messageDetail.subject) {
        alert.validationType = ValidationType.WARNING;
        alert.message = ToasterMessages.WARNING.WITHOUT_SUBJECT;
        alert.messageProperty = "subject";
    }
    return alert;
};

export const validateAddSecurityQuestion = (name: string, value: string) => {
    //This is to put the character limit for question title and question
    if (name === "questionTitle" && value.length > 50) {
        return false;
    }
    if (name === "question" && value.length > 100) {
        return false;
    }
};

export const validateRecipientQnA = (rowData: IRecipientModel, recipients: IRecipientModel[], showAlert: boolean) => {
    if (!rowData.emailAddress) {
        showAlert && AppNotifier.Warning(ToasterMessages.WARNING.REQUIRE_RECIPIENT_EMAIL);
        return false;
    } else if (!isValidEmailAddress(rowData.emailAddress)) {
        showAlert && AppNotifier.Warning(ToasterMessages.WARNING.INVALID_EMAIL_FORMAT);
        return false;
    } else if (isEmailAddressDuplicate(rowData.emailAddress, recipients)) {
        showAlert && AppNotifier.Warning(ToasterMessages.WARNING.RECIPIENT_ALREADY_EXIST);
        return false;
    } else if (!rowData.question?.trim()) {
        showAlert && AppNotifier.Warning(ToasterMessages.WARNING.REQUIRE_QUESTION);
        return false;
    } else if (!rowData.answer?.trim()) {
        showAlert && AppNotifier.Warning(ToasterMessages.WARNING.REQUIRE_ANSWER);
        return false;
    }
    return true;
};

export const isEmailAddressDuplicate = (email: string, recipients: IRecipientModel[]): boolean => {
    return recipients.filter(x => x.emailAddress === email).length > 1;
};

export const validateAllRecipientsQnA = (recipients: IRecipientModel[]) => {
    let isValid = true;
    for (let i = 0; i < recipients.length; i++) {
        isValid = validateRecipientQnA(recipients[i], recipients, true);
        if (!isValid) {
            break;
        }
    }
    return isValid;
};
export const validateAllRecipientsQnAComposeModal = (
    recipients: IRecipientModel[],
    messageDetail?: ISentMessageModel
) => {
    let isValid = true;
    if (messageDetail.authenticationMethod === AuthenticationMethod.QUESTIONANSWER) {
        for (let i = 0; i < recipients.length; i++) {
            isValid = validateRecipientQnA(recipients[i], recipients, false);
            if (!isValid) {
                break;
            }
        }
    }
    return isValid;
};
export const invalidFolderNameRegex = new RegExp(/[\\\/:\*\?\"<>\|]/);

export const isFolderNameValid = (folderName: string) => {
    return !invalidFolderNameRegex.test(folderName);
};

//exclude non ASCII chars to avoid invalid metadata error from Azure
export const invalidFileNameRegex = new RegExp(/[\\/:*?"<>|\u00A0]|[^\x00-\x7F]/g);

export function validateQuestion(question: string) {
    if (question.length <= 100) {
        return true;
    }
    return false;
}

export function validateQuestionTitle(questionTitle: string) {
    if (questionTitle.length <= 50) {
        return true;
    }
    return false;
}
